<template>
    <div>         
        <!-- CONTENIDO PRINCIPAL -->
         <div class="container contenido_principal" style="margin-bottom:5rem">
            <boton-atras nombre_ruta="quienesSomos"></boton-atras>

             <div>
                <div>
                    <h6 class="subtitulo mb-2">Comité Técnico</h6>
                    <div class="lineaNegra"></div><div class="mt-1 mb-2 lineaNegra2"></div>
                <h5 class="mt-5">El comité está integrado de la siguiente forma: </h5>
                <center class="mt-3">
                    <div class="comite-tecnico">
                        <p class="my-0"> <strong>Prof. Miguel Prado Tobilla</strong> </p>
                        <p class="text-muted small my-0">Director Operativo del Foprovep</p>
                        <p class="text-muted small my-0">Tlf.: (961) 6129244,  (961) 6121335 | cel. 044 9616584521</p>
                        <hr>
                        <p class="my-0">Titular de la Secretaria de Hacienda</p>
                        <p class="text-muted small my0">Presidente</p>
                        <hr>
                        <p class="my-0">Titular de la Coordinación Operativa del FOPROVEP</p>
                        <p class="text-muted small my0">Secretario Técnico</p>
                        <hr>
                        <p class="my-0">Titular de la Secretaria General de Gobierno</p>
                        <p class="text-muted small my0">Vocal</p>
                        <hr>
                        <p class="my-0">Titular de la Dirección de Patrimonio del Instituto de la Consejería Jurídica y de Asistencia Legal</p>
                        <p class="text-muted small my0">Vocal</p>
                    </div>
                </center>
                </div>
                <p class="parrafo-contenido mt-5">
                    Todos tendrán derecho a voz y voto y en caso de empate el presidente tiene el voto de calidad. Podrán ser invitados un representante del Fiduciario, del Fideicomitente que en este caso es enviado por la Subsecretaría de Entidades Paraestatales y de la Función Pública y por último, cualquier persona que cuyo cargo o actividad estén relacionados con los asuntos a tratar y que a juicio del presidente o del secretario técnico, sea indispensable su presencia en la celebración de la sesión, para lo cual todas estas personas podrán tener voz, más no voto.
                    Los miembros del comité a excepción del secretario técnico podrán nombrar a un suplente y el presidente podrá delegar dicha función en el Subsecretario de Administración y el resto en cualquier funcionario público de su dependencia siempre y cuando ostente el cargo de Director. Se sesiona cada tercer miércoles de cada mes, las invitaciones se envían 5 días hábiles antes de cada sesión.

                </p>               
            </div>

            
         </div>
    </div>
</template>
<script>
import botonAtras from './../../button-atras'
export default {
    data: function(){
        return{
            // variables
        }
    },
    components:{
        botonAtras
    },
    mounted(){
        window.scrollTo(0, 0);
    }
}
</script>

<style scoped>

/* @media only screen and (max-device-width : 900px) {
    .subtitulo{ 
        font-size: 1.4rem !important;
        margin-top: 1.6rem !important;
    }
    .contenido_principal h5{ font-size: 1rem; }
    .parrafo-contenido{ font-size: 1em !important; }
}

.parrafo-contenido{
    font-size: 1.3em;
    line-height: 1.8em;
} */

.comite-tecnico{
    width:100%; padding:1rem 2rem; 
    border-radius:15px;
    text-align:left;
    box-shadow: 3px 8px 17px -13px rgba(0,0,0,0.75) !important;
    border-left: 7px solid #621132;
}

</style>